<template>
  <div class="container" id="topic_top">
    <div class="w1200 flex">
      <div v-show="sysinfoshow">
        <img @click="toArticle" v-if="logoCover" :src="logoCover" />
        <img @click="toArticle" v-else src="../assets/images/logo.png" />
      </div>

      <div class="nav">
        <span @click="toArticle(1)" :class="{ checked: tabIndex == 1 }">首页</span>
        <span @click="toHome(2)" :class="{ checked: tabIndex == 2 }">期刊</span>
        <!-- <span @click="tosubject(3)" :class="{ checked: tabIndex == 3 }">学科导航</span> -->
        <!-- <span :class="{ checked: tabIndex == 7 }">
          <el-menu class="el-menu-demo" :default-active="defaultActive" mode="horizontal">
            <el-submenu index="2-1">
              <template slot="title">技术领域分析</template>
              <el-menu-item index="trend" @click="toTrend(7)">检索分析</el-menu-item>
              <el-menu-item index="info" @click="toinfo(7)">学科资讯</el-menu-item>
            </el-submenu>
          </el-menu>
        </span> -->
        <span @click="toAicenter(5)" :class="{ checked: tabIndex == 5 }">文献服务平台</span>
        <span @click="toSubjectGateway()">学科知识库</span>
        <span @click="toAiHelp(4)" :class="{ checked: tabIndex == 4 }">资源助手</span>
        <span @click="toHelp(6)" :class="{ checked: tabIndex == 6 }">使用帮助</span>
        <!-- <span @click="toTupu(6)" :class="{ checked: tabIndex == 6 }"
          >知识图谱</span
        > -->
      </div>
      <div v-if="!info || info.ipUser" class="login">
        <!-- <div class="mobile-container">
          <span @mouseenter="showMobileImg = true" @mouseleave="showMobileImg = false">移动端</span>
          <img v-if="showMobileImg" src="../assets/images/jxywx.png" width="200px" height="200px" alt="移动端二维码" class="mobile-qrcode"></img>
        </div> -->
        您好,读者！请 <span @click="toLogin">登录</span>
      </div>
      <!-- 不是ip用户 -->
      <div class="login" v-if="info && !info.ipUser">
        <!-- 您好， -->

        <!-- <div class="mobile-container">
          <span @mouseenter="showMobileImg = true" @mouseleave="showMobileImg = false">移动端</span>
            <div class="wxImgBox" v-if="showMobileImg">
              <img v-if="isWx" src="../assets/images/jxywx.png" width="200px" height="200px" alt="移动端二维码" class="mobile-qrcode"></img>
              <div v-else>
                <img :src="qrcodeUrl" width="200px" height="200px" alt="移动端二维码" class="mobile-qrcode"></img>
                <div class="wxImgText">请使用微信扫描二维码绑定微信账号</div>
              </div>
            </div>
        </div> -->

        <span class="mine line1" @click="toMine">个人信息</span>
        <!-- <span
          class="mine line1"
          @click="toMine"
          v-if="!info.ipUser"
          :title="$store.state.userName"
          >{{ $store.state.userName }}</span
        >
        <span class="mine line1" @click="toMine" v-if="info.ipUser">{{
          info.schoolName
        }}</span> -->
        <i class="addicon" v-show="info.isSubscribe"></i>
        <div class="loginout" v-if="token" @click="handleLoginout">退出</div>
      </div>

      <!-- 是ip用户 显示学校 -->
      <!-- <div class="login" v-if="info && info.ipUser">
        <span class="mine" @click="toMine">{{ info.schoolName }}</span>
        <div class="loginout" v-if="token" @click="handleLoginout">退出</div>
      </div> -->
      <div v-if="ipWarning" class="ip-warning">
        {{ ipWarning }}
      </div>
    </div>
    <el-dialog title="登录" :visible.sync="loginDialog" width="30%">
      <div class="loginForm">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="65px" class="demo-ruleForm">
          <el-form-item label="用户名" prop="username">
            <el-input type="name" v-model="ruleForm.username"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="ruleForm.password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="loginDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import urlobj from "@/api/baseurl.js";
export default {
  name: "top",
  data() {
    return {
      token: "",
      showMobileImg: false,
      userName: "",
      loginDialog: false,
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ message: "请输入用户名", required: true, trigger: "blur" }],
        password: [{ message: "请输入密码", required: true, trigger: "blur" }],
      },
      tabIndex: 2,
      info: null,
      defaultActive: null,
      isWx: false,
      qrcodeUrl: "",
      ipUser: false,
      logoCover: "",
      sysName: "",
      sysinfoshow: false,
      ipWarning: "",
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(val) {
        this.token = localStorage.getItem("jyx_token");
        this.$store.commit("getUserName", localStorage.getItem("userName"));
        this.defaultActive = "";
        if (val.name == "articleSearch" || val.name == "Article" || val.name == "articleDetail" || val.name == "topicsearch" || val.name == "author" || val.name == "authorDetail" || val.name == "upload") {
          this.tabIndex = 1;
          // this.getInfo();
        }
        if (val.name == "home" || val.name == "homeDetail") {
          this.tabIndex = 2;
          // this.getInfo();
        }
        if (val.name == "AiHelp") {
          this.tabIndex = 4;
          // this.getInfo();
        }
        if (val.name == "answers_list") {
          this.tabIndex = 100;
          // this.getInfo();
        }
        if (val.name == "Help") {
          this.tabIndex = 6;
          // this.getInfo();
        }
        if (val.name == "trend" || val.name == "trendList" || val.name == "info") {
          this.tabIndex = 7;
          // this.getInfo();
          if (val.name == "trend" || val.name == "trendList") {
            this.defaultActive = "trend";
          } else {
            this.defaultActive = "info";
          }
        }
        if (val.name == "subject") {
          this.tabIndex = 3;
          // this.getInfo();
        }
        if (val.name == "mine") {
          this.tabIndex = -1;
          // this.getInfo();
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.ipWarning = localStorage.getItem("ipWarning") || "";
    this.getInfo();
  },
  methods: {
    getwxcode() {
      this.$http({
        url: "/api/v1/wx/app/create/activity-code",
        method: "GET",
        responseType: "blob",
      })
        .then(res => {
          this.qrcodeUrl = URL.createObjectURL(res);
        })
        .catch(error => {
          this.$message.error("二维码获取失败");
          // console.error("二维码请求错误:", error);
        });
    },
    getInfo() {
      // ===== 添加缓存判断：如果已有info数据，不再请求 =====
      if (this.info) return;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      })
        .then(res => {
          this.info = res.data;
          this.ipUser = this.info.ipUser;
          // 调用mixin中的getSystemInfo方法获取logoCover
          localStorage.removeItem("sysName");
          this.getSystemInfo(res.data.schoolName);
        })
        .catch(error => {
          console.error("获取用户信息失败:", error);
          this.sysinfoshow = true;
        });
    },
    getSystemInfo(schoolName) {
      // 这里使用假设的接口路径，请替换为实际获取系统名称的接口
      this.$http({
        url: `/api/v1/system/ipuser/customer/info?schoolName=${encodeURIComponent(schoolName)}`, // 修复：URL 编码 schoolName
        method: "GET",
      })
        .then(res => {
          if (res.code === 200) {
            this.sysinfoshow = true;
            this.sysName = res.data.sysName; // 确保正确赋值
            this.logoCover = res.data.cover; // 确保正确赋值
            localStorage.setItem("sysName", this.sysName);
          }
        })
        .catch(error => {
          this.sysinfoshow = true;
          console.error("获取系统名称失败:", error);
        });
    },
    toHome(index) {
      this.tabIndex = index;
      sessionStorage.removeItem("heightSearchWord");
      this.$router.push({ path: "/home" });
    },
    toArticle(index) {
      this.tabIndex = index;
      sessionStorage.removeItem("heightSearchWord");
      this.$router.push({ path: "/articleSearch" });
    },
    tosubject(index) {
      this.tabIndex = index;
      sessionStorage.removeItem("heightSearchWord");
      this.$router.push({ path: "/subject" });
    },
    toAiHelp(index) {
      this.tabIndex = index;
      this.$router.push({ path: "/AiHelp" });
    },
    toHelp() {
      this.$router.push({ path: "/help" });
    },
    toTrend(index) {
      this.tabIndex = index;
      this.$router.push({ path: "/trend" });
    },
    toinfo(index) {
      this.tabIndex = index;
      this.$router.push({ path: "/info" });
    },
    toSubjectGateway() {
      const { href } = this.$router.resolve({
        path: `/subjectGateway/index`,
      });
      window.open(href, "_self");
    },
    toTupu() {
      window.open("https://jyx.cxstar.cn/tp/");
    },
    toMine() {
      if (this.info.ipUser) {
        const { href } = this.$router.resolve({
          path: "/lg?word=true&asp=true",
          query: { ipFrom: true },
        });
        window.open(href, "_blank");
        return;
      }
      window.open(`/asp/self_setting?openFlag=true&self=true`, "_blank");
      // this.$router.push({ path: "/asp/self_setting" });
    },
    toAicenter() {
      if (this.info.ipUser) {
        // this.$router.push({ path: "/lg?asp=true", query: { ipFrom: true } });
        // return;
        const { href } = this.$router.resolve({
          path: "/lg?word=true&asp=true",
          query: { ipFrom: true },
        });
        window.open(href, "_blank");
      } else {
        window.open(`/asp/`, "_blank");
      }
    },
    toLogin() {
      window.open(`/lg?word=true`, "_blank");
      // this.$router.push({ path: "/lg", query: { word: true } });
      // this.loginDialog = true;
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.resetFields();
      // });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postBody = {
            username: this.ruleForm.username,
            password: this.ruleForm.password,
          };
          this.$http({
            url: "/api/v1/login",
            method: "POST",
            data: postBody,
          }).then(res => {
            if (res.code == 200) {
              this.$message.success("登录成功");
              localStorage.setItem("userName", this.ruleForm.username);
              this.$store.commit("getUserName", this.ruleForm.username);
              localStorage.setItem("jyx_token", res.token);
              this.loginDialog = false;
            }
          });
        } else {
          return false;
        }
      });
      // let postBody = {
      //   username: "admin123",
      //   password: "12345678",
      // };
      // this.$http({
      //   url: "/api/v1/login",
      //   method: "POST",
      //   data: postBody,
      // }).then(res => {
      //   if (res.code == 200) {
      //     this.$message.success("登录成功");
      //     this.$store.commit("getUserName", "哈哈哈");
      //     localStorage.setItem("token", res.token);
      //   } else {
      //     this.$message.error(res);
      //   }
      // });
      // return;
      // location.href = `${urlobj.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
      // this.$router.push({ path: "/denglu" });
    },
    // 退出
    handleLoginout() {
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: "api/v1/logout",
            method: "POST",
          }).then(res => {
            if (res.code == 200) {
              this.info = null;
              this.$message.success("退出成功");
              localStorage.removeItem("jyx_token");
              localStorage.removeItem("userName");
              this.$store.commit("getUserName", "");
              // 退出时清空IP警告
              localStorage.removeItem("ipWarning");
              this.ipWarning = "";
              setTimeout(() => {
                this.$router.push({ path: "/lg?word=true" });
              }, 500);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: linear-gradient(90deg, #006eb3 0%, #2d8cf0 100%) #2d8cf0;
  min-height: 85px;
  .addicon {
    width: 7px;
    height: 7px;
    background: #ff0000;
    border-radius: 3.5px;
    position: relative;
    margin-top: -12px;
    margin-left: 3px;
  }
  .w1200 {
    padding: 15px 0;
    color: #fff;
    align-items: center;
    width: 1300px;
    img {
      cursor: pointer;
      max-width: 260px;
      max-height: 50px;
    }
    .nav {
      margin-left: 120px;
      display: flex;
      .checked {
        &::before {
          content: "";
          position: absolute;
          bottom: -10px;
          width: 100%;
          height: 2px;
          background: #fff;
          left: 0;
        }
      }
      span {
        position: relative;
        margin: 0 25px;
        cursor: pointer;
        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 20px;
          background: #53aecc;
          right: -31px;
          top: 1px;
        }
        &:last-of-type {
          &::after {
            display: none;
          }
        }
      }
      ::v-deep .el-menu--horizontal {
        top: 0 !important;
      }
      ::v-deep .el-menu-demo {
        border: none;
        background: none;
        .el-submenu__title {
          height: auto;
          line-height: normal;
          border: none;
          background: none;
          color: #fff;
          font-size: 16px;
          padding: 0;
        }
        .el-icon-arrow-down {
          display: none;
        }
      }
    }
    .login {
      margin-left: auto;
      font-size: 14px;
      display: flex;
      span {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .loginout {
      font-size: 14px;
      cursor: pointer;
      margin-left: 15px;
    }
  }
  .loginForm {
    padding: 0 30px;
    ::v-deep .el-form-item__content {
      text-align: right;
    }
  }
}
</style>
<style lang="scss">
.el-menu--horizontal {
  top: 57px !important;
}
.el-menu--popup {
  width: 100px;
  min-width: 100px !important;
  .el-menu-item {
    text-align: center;
    font-size: 16px;
    color: #333 !important;
    &:hover {
      color: #2d8cf0 !important;
      background: #f0f7f7 !important;
    }
  }
}
.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #2d8cf0 !important;
  background: #f0f7f7 !important;
}

.mobile-container {
  position: relative;
  display: inline-block;
  margin-right: 15px;
  span {
    cursor: pointer;
  }
}
.wxImgBox {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: white;
  padding: 10px;
  border-radius: 4px;
}
// .mobile-qrcode {
// }

/* 为了美观，可以添加一个小三角指示 */
.wxImgBox::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border: 10px solid transparent;
  border-bottom-color: white;
}
.wxImgText {
  font-size: 12px;
  color: #333;
  text-align: center;
}
.ip-warning {
  color: red;
  padding: 8px 0;
  text-align: center;
  font-size: 14px;
  /* font-weight: bold; */
  position: absolute;
  margin-left: 1080px;
  margin-top: 51px;
}
</style>
